module.exports = __webpack_public_path__ + "media/images/icons/chevron-right-icon-8345d3a9be2743eb60593c26a547ab54.svg";